export default __webpack_public_path__ + "static/media/heart.32b5e563.png";